



















import { createComponent, computed } from "@vue/composition-api";
import BaseCounter from "@web-components/components/BaseCounter.vue";

interface DrinkCounterProps {
  value: number | string;
  min: number;
  max: number;
  title: string;
  description: string;
}

export default createComponent({
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  components: {
    BaseCounter
  },
  setup(props: Readonly<DrinkCounterProps>, { emit }) {
    const localValue = computed({
      get: () => props.value,
      set: (value: number | string) => {
        emit("input", value);
      }
    });

    return { localValue };
  }
});
